export default __webpack_public_path__ + "088e8541ee1d4eae1a3b9c06b0467b18.png";